import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useRouteMatch, useHistory, useParams } from "react-router-dom";

import { createExternalForm, updateExternalForm } from 'actions/forms/external';
import { toggleFormManageView, fetchForm } from 'actions/forms/forms';

import { Card, Accordion, Button } from 'react-bootstrap';

import cx from 'classnames';
import _ from 'lodash';

import CustomToggle from '../../components/customToggle';
import FormPreview, { ExternalFormPreview } from '../../components/formPreview';

import { getBaseUrl } from 'services/util';

import styles from '../../forms.module.scss';

export default function ExternalFormConfigurations() {
  const dispatch = useDispatch();
  const textareaRef = React.createRef(null);
  const { formId } = useParams();

  const history = useHistory();
  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const completionCode = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0/forms/external/form-submit?email={email}&firstname={firstname}&lastname={lastname}&company={company}&title={title}&workphone={workphone}`
  
  const currentForm = useSelector(state => _.get(state, "forms.currentForm", {}));

  const [state, setState] = useState({
    name: '',
    url: '',
    formPreview: false,
    activatedKey: "1",
    errors: {}
  })

  useEffect(() => {
    dispatch(toggleFormManageView(true))

    return () => {
      dispatch(toggleFormManageView(false))
    };
  }, [])

  useEffect(() => {
    if (formId && formId != "new") {
      dispatch(fetchForm(formId))
      return;
    }
  }, [formId])

  useEffect(() => {
    if(currentForm) {
      setState(state => {
        return {
          ...state,
          name: _.get(currentForm, 'name', ''),
          url: _.get(currentForm, 'configuration.url', '')
        }
      })
    }
  }, [currentForm])

  const handleUrlChange = (e) => {
    setState((state) => {
      return {
        ...state,
        url: e.target.value,
        errors: {}
      }
    })
  }

  const handleNameChange = (e) => {
    setState(state => {
      return {
        ...state,
        name: e.target.value,
        errors: {}
      }
    })
  }

  const handleCustomToggle = (key) => {
    setState(state => {
      return {
        ...state,
        activatedKey: key
      }
    })
  }

  const handleCopyCode = () => {
    handleCustomToggle("3")
    navigator.clipboard.writeText(textareaRef.current.value)
  }

  const handleFinish = () => {
    var url = `${baseUrl}/integration-settings/forms?type=external`;
    history.push(url);
  }

  const isValidURL = (url) => {
    // Regular expression for a basic URL pattern
    var urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;

    // Test the provided URL against the pattern
    return urlPattern.test(url);
  }

  const validateForm = () => {
    const errors = {};

    let isValid = isValidURL(state.url);
    if (!isValid) {
      errors.url = 'please enter a valid URL'
    }

    if (!state.name || state.name.trim() === "") {
      errors.name = "Enter a valid form name";
    }

    return errors;
  }

  const handleSaveClick = (key) => {
    const errors = validateForm(state.request);
    setState(state => {
      return {
        ...state,
        errors: errors
      }
    })

    if (Object.keys(errors).length !== 0) {
      return;
    }

    var request = {
      name: state.name,
      url: state.url,
    }

    if (!_.get(currentForm, 'id', null)) {
      dispatch(createExternalForm(request));
    } else {
      dispatch(updateExternalForm(currentForm.id, request))
    }

    handleCustomToggle("2")
  }

  return (
    <div className={styles.formConfigurationContainer}>
      <Accordion className={styles.accordion} defaultActiveKey={state.activatedKey} activeKey={state.activatedKey}>
        <Card>
          <Card.Header>
            <div className={styles.title}>
              <div className={styles.icon}>
                {state.activatedKey != "1" ? <i className="cleverstory-tick"></i> : "1"}
              </div>
              <div className={styles.name}>Form URL</div>
            </div>
            {parseInt(state.activatedKey) > 1 && <CustomToggle eventKey="1" onClick={() => handleCustomToggle("1")}>Edit form</CustomToggle>}
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              <div className={styles.externalFormContainer}>
                <div className={cx(styles.left, styles.external)}>
                  <div className={styles.externalFormEditor}>
                    <div className={styles.externalFormEditorInner}>
                      <div className={styles.formTitle}>Enter Name</div>
                      <input className={styles.formInput}
                        type='text'
                        value={state.name}
                        onChange={handleNameChange}
                        placeholder='Enter form name'
                      />
                      <p className={styles.error}>{_.get(state, 'errors.name', '')}</p>
                    </div>
                    <div className={styles.externalFormEditorInner}>
                      <div className={styles.formTitle}>Enter your URL here</div>
                      <input className={styles.formInput}
                        type='text'
                        value={state.url}
                        onChange={handleUrlChange}
                        placeholder='Enter your URL here'
                      />
                      <p className={styles.error}>{_.get(state, 'errors.url', '')}</p>
                    </div>
                  </div>
                </div>
                <div className={styles.right}>
                  <div className={styles.contactForm} id="contact_form">
                    {!isValidURL(state.url) && <div>Enter form url to display!</div>}
                    {isValidURL(state.url) && <ExternalFormPreview url={state.url} />}
                  </div>
                </div>
              </div>
              <div className={cx(styles.bottom, styles.doneButtonContainer, styles.border_top, styles.pt_30)}>
                <CustomToggle eventKey="1" handleClick={() => handleSaveClick()} isComplete={true} disabled={!state.url}>Save & Continue</CustomToggle>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header className={cx({ [styles.disabled]: parseInt(state.activatedKey) < 2 }, { [styles.completed]: parseInt(state.activatedKey) > 2 })}>
            <div className={styles.title}>
              <div className={styles.icon}>
                {parseInt(state.activatedKey) > 2 ? <i className="cleverstory-tick"></i> : "2"}
              </div>
              <div className={styles.name}>Copy the code</div>
            </div>
            <CustomToggle eventKey="2" onClick={() => handleCustomToggle("2")}>Copy Code</CustomToggle>
          </Card.Header>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              <div className={styles.bodyContainer}>
                <div className={styles.copyContainer}>
                  <div className={styles.content}>
                    <textarea ref={textareaRef} readOnly={true} value={completionCode}></textarea>
                  </div>
                </div>
              </div>
              <div className={cx(styles.bottom, styles.doneButtonContainer)}>
                <CustomToggle eventKey="2" onClick={() => handleCopyCode()} isComplete={true}>Copy Code</CustomToggle>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        
        <Card>
          <Card.Header className={cx({ [styles.disabled]: parseInt(state.activatedKey) < 2 }, { [styles.completed]: parseInt(state.activatedKey) > 3 })}>
            <div className={styles.title}>
              <div className={styles.icon}>
                {parseInt(state.activatedKey) > 3 ? <i className="cleverstory-tick"></i> : "3"}
              </div>
              <div className={styles.name}>Paste the code</div>
            </div>
            <CustomToggle eventKey="3" onClick={() => handleCustomToggle("3")}>View the instruction</CustomToggle>
          </Card.Header>
          <Accordion.Collapse eventKey="3">
            <Card.Body>
              <PasteCode />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      {parseInt(state.activatedKey) > 1 &&
        <div className={styles.finishButton}>
          <Button className={styles.actionButton}
            onClick={handleFinish}
            size="sm"
            variant="primary"
          >
            Done
          </Button>
        </div>
      }
    </div>
  )
}


function PasteCode() {
  return (
    <div className={styles.bodyContainer}>
      <div className={styles.pasteCode}>
        <div className={styles.section}>
          <div className={styles.title}>Copy the provided URL and paste it into your third-party's form 
          redirection field to enable seamless communication between the form provider and Cleverstory. 
          This will ensure data is accurately captured and synced between the two platforms.</div>
        </div>
      </div>
    </div>
  )
}